import {match} from 'ts-pattern';

import {BatchVehiclePricingStatus, RowStatus} from '../../../types/api/api';

export function pricingStatusToRowStatus(status: BatchVehiclePricingStatus): RowStatus {
  return match<BatchVehiclePricingStatus, RowStatus>(status)
    .with('priced', () => 'success')
    .with('failed', () => 'error')
    .with('pending', () => 'warning')
    .exhaustive();
}
